import { MessageCircle } from "lucide-react";
import { useBranding } from "../lib/branding";

export const waNumber = (b) => (b?.whatsapp || "").replace(/\D/g, "");

export const waContactLink = (b, text) => {
  const company = b?.company || "PossessionCheck.com";
  const message =
    text || `Hello ${company}, I would like to book a home inspection.`;
  return `https://wa.me/${waNumber(b)}?text=${encodeURIComponent(message)}`;
};

export function WhatsAppFab() {
  const b = useBranding();
  if (waNumber(b).length < 10) return null;
  return (
    <a
      href={waContactLink(b)}
      target="_blank"
      rel="noreferrer"
      data-testid="whatsapp-floating-button"
      title="Chat on WhatsApp"
      className="tap fixed bottom-5 right-5 z-50 hidden h-14 items-center gap-2 rounded-full bg-[#25D366] px-5 font-semibold text-white shadow-xl hover:bg-[#1ebe5a] sm:flex"
    >
      <MessageCircle className="h-5 w-5" />
      <span className="hidden sm:inline">Chat on WhatsApp</span>
    </a>
  );
}
